import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';

export default function useCurrentProjectChooser(url, projectUrl) {
    const router = useRouter();

    function onProject(event) {
        const detail = event.detail ? event.detail : null;
        if (detail) {
            reRouteToProject(detail);
        }
    }

    function reRouteToProject({ projectId, code, name }) {
        var newRoute = projectId ? projectUrl.replace(':projectId', projectId) : url;
        newRoute = code ? newRoute.replace(':vatNumber', code) : newRoute;
        router.push(newRoute).catch((e) => {});
    }

    onMounted(() => document.addEventListener('onProjectselector', onProject));
    onUnmounted(() => document.removeEventListener('onProjectselector', onProject));

    return {};
}
